module.exports = __webpack_public_path__ + "static/media/register-CA-to-aws-iot-core.9fba193c.jpg";